import { FaArrowRight } from "react-icons/fa";
import { heroChips, profile } from "../data";

function Hero() {
  return (
    <section className="hero container" id="home">
      <div className="hero-meta">
        <span>
          <span className="status-dot" /> Available for PFE · Jan 2027
        </span>
        <span>{profile.role}</span>
        <span>Based in {profile.location}</span>
      </div>

      <h1 className="hero-title">
        Backends that <span className="mark">ship,</span> scale and <em>stay up.</em>
      </h1>

      <div className="hero-badge" aria-hidden="true">
        <svg viewBox="0 0 120 120">
          <defs>
            <path id="badge-circle" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" />
          </defs>
          <text>
            <textPath href="#badge-circle" textLength="286">
              Available for PFE · Jan 2027 · Backend &amp; DevOps ·
            </textPath>
          </text>
        </svg>
        <span className="hero-badge-star">✦</span>
      </div>

      <div className="hero-foot">
        <div>
          <p className="hero-bio">
            I'm Oumayma, a final-year Software Engineering student at ENIAD focused on Java/Spring backend development and DevOps. Looking for a 6-month
            end-of-studies internship (PFE) starting January 2027.
          </p>
          <div className="chips">
            {heroChips.map((chip) => (
              <span className="chip" key={chip}>
                {chip}
              </span>
            ))}
          </div>
        </div>

        <div className="hero-actions">
          <a href="#contact" className="btn-dark">
            Work with me
            <span className="btn-dot">
              <FaArrowRight />
            </span>
          </a>
          <a href="#projects" className="btn-ghost">
            See my work
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
